import styled from "styled-components";

export const ActionsWrapper = styled.div`
  position: sticky;
  top: 0px;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid ${(props) => props.theme.fontColor};
  background-color: ${(props) => props.theme.bottomColor};
  z-index: 1;
  margin-bottom: 16px;
  padding: 10px;
  gap: 16px;
`;

export const PaymentWrapper = styled.div`
  width: 100%;
  overflow: auto;
`;

export const PaymentTable = styled.table`
  width: 100%;
  &,
  td {
    border: 1px solid ${(props) => props.theme.fontColor};
  }
  
  td {
    text-align: center;
  }


    tr td:first-child, tr, th:first-child{
        position: sticky;
        left: 0px;
        background-color: ${props => props.theme.bottomColor};
    }

    td:not(:first-child){
        min-width: 140px;
    }

`;


export const NotFound = styled.div`
  text-align: center;
  margin-top: 16px;

  p {
    color: ${(props) => props.theme.fontColor}80;
    font-weight: bold;
  }
`;